import { useState } from 'react';
import styles from './NewFooter.module.scss';
import AdminLoginModal from './AdminLoginModal';
import { Dropdown } from 'Components';
import { Menu } from 'antd';

interface FooterProps {
	isAdminLogin: boolean;
}

const NewFooter: React.FC<FooterProps> = ({ isAdminLogin }) => {
	const [showModal, setShowModal] = useState(false);

	const contents = [
		{ label: 'Contact', onclick: () => console.log('test') },
		{ label: 'Terms of Use', onclick: () => console.log('test') },
		{ label: 'Privacy', onclick: () => console.log('test') },
		...(isAdminLogin
			? [
					{
						label: 'Venza Admin',
						onclick: () => setShowModal(true)
					}
			  ]
			: [])
	];

	const hideModal = () => setShowModal(false);

	return (
		<>
			<div className={styles.root}>
				{contents.map((el, index) => (
					<FooterItem
						key={index}
						label={el.label}
						onclick={el.onclick}
					/>
				))}
				<LanguageDropDown />
			</div>
			<AdminLoginModal visible={showModal} onCancel={hideModal} />
		</>
	);
};

const LanguageDropDown = () => {
	const menu = (
		<Menu style={{ borderRadius: '6px' }}>
			<Menu.Item>English</Menu.Item>
			<Menu.Item disabled>Spanish</Menu.Item>
			<Menu.Item disabled>French</Menu.Item>
			<Menu.Item disabled>German</Menu.Item>
		</Menu>
	);

	return (
		<Dropdown overlay={menu} className={styles.languageBtn}>
			English
		</Dropdown>
	);
};

interface FooterItemProps {
	label: string;
	onclick: () => void;
}

const FooterItem: React.FC<FooterItemProps> = ({ label, onclick }) => {
	return (
		<div className={styles.label} onClick={onclick}>
			{label}
		</div>
	);
};

export default NewFooter;
